const OWNABLE_MODULES = [
  "riskAssessment",
  "medkitlog",
  "incidentReport",
  "environmentalReport",
  "inspection",
  "tickets",
];

const ROUTE_MODULES = [
  ["/app/riskAssessment", "riskAssessment"],
  ["/app/asaMeeting", "riskAssessment"],
  ["/app/tickets", "tickets"],
  ["/app/dangerousGoods", "dangerousGoods"],
  ["/app/medkitlogs", "medkitlog"],
  ["/app/incidentReports", "incidentReport"],
  ["/app/environmentalReports", "environmentalReport"],
  ["/app/managedInstructions", "managedInstruction"],
  ["/app/instructionsHub", "managedInstruction"],
  ["/app/instructionFolder", "managedInstruction"],
  ["/app/instructions", "managedInstruction"],
  ["/app/employee", "users"],
  ["/app/instructionCategory", "operatingInstruction"],
  ["/app/operatingInstructions", "operatingInstruction"],
  ["/app/betriebsanweisungTemplate", "operatingInstruction"],
  ["/app/inspectionCategory", "inspection"],
  ["/app/examination", "examination"],
  ["/app/proofCategory", "proof"],
  ["/app/files", "documents"],
  ["/app/settings/users", "users"],
  ["/app/settings/profile", null],
  ["/app/settings", "settings"],
];

const HOME_PAGES = [
  ["tickets", "/app/tickets/all"],
  ["managedInstruction", "/app/instructionsHub"],
  ["examination", "/app/examination"],
  ["riskAssessment", "/app/riskAssessmentCategory"],
  ["dangerousGoods", "/app/dangerousGoods"],
  ["operatingInstruction", "/app/instructionCategory"],
  ["proof", "/app/proofCategory"],
  ["inspection", "/app/inspectionCategory"],
  ["medkitlog", "/app/reports"],
  ["incidentReport", "/app/reports"],
  ["environmentalReport", "/app/reports"],
  ["documents", "/app/files"],
];

export function homePath() {
  const hit = HOME_PAGES.find(([module]) => canView(module));
  return hit ? hit[1] : "/app/settings/profile";
}

export function currentAccess() {
  try {
    const user = JSON.parse(localStorage.getItem("userData"));
    return (user && user.access) || null;
  } catch (e) {
    return null;
  }
}

export function hasPermission(permission) {
  try {
    const user = JSON.parse(localStorage.getItem("userData"));
    return ((user && user.permissions) || []).includes(permission);
  } catch (e) {
    return false;
  }
}

export function isLegacyReadOnly() {
  return !currentAccess() && legacyReadOnly();
}

function legacyReadOnly() {
  try {
    return !!JSON.parse(localStorage.getItem("userData")).readOnly;
  } catch (e) {
    return false;
  }
}

export function moduleForPath(path) {
  const match = ROUTE_MODULES.find(([prefix]) =>
    String(path || "").startsWith(prefix)
  );
  return match ? match[1] : null;
}

const REPORT_TABS = ["medkitlog", "incidentReport", "environmentalReport"];

export function moduleForRoute(route) {
  const path = String((route && route.path) || "");
  if (path.startsWith("/app/reports")) {
    const tab = route.query && route.query.tab;
    return REPORT_TABS.includes(tab) ? tab : null;
  }
  return moduleForPath(path);
}

export function levelFor(module) {
  const access = currentAccess();
  if (!access) return legacyReadOnly() ? "L" : "V";
  if (!module) return "V";
  return (access[module] && access[module].level) || "-";
}

export function isAnonymized(module) {
  const access = currentAccess();
  return !!(access && access[module] && access[module].restriction === "anonymized");
}

export function canView(module) {
  return levelFor(module) !== "-";
}

export function canCreate(module) {
  const level = levelFor(module);
  if (level === "E") return OWNABLE_MODULES.includes(module);
  return level === "A" || level === "V";
}

export function canEdit(module) {
  const level = levelFor(module);
  if (level === "E") return OWNABLE_MODULES.includes(module);
  return ["A", "V", "B"].includes(level);
}

export function canDelete(module) {
  return canCreate(module);
}

export function canManageStructure(module) {
  return ["A", "V"].includes(levelFor(module));
}

export function canEditStructure(module) {
  return ["A", "V", "B"].includes(levelFor(module));
}

export function canBulkEdit(module) {
  return ["A", "V", "B"].includes(levelFor(module));
}

export function canBulkDelete(module) {
  return ["A", "V"].includes(levelFor(module));
}

const CREATE_ACTIONS = [
  "newDocument",
  "openForm",
  "openUpload",
  "openImport",
  "import",
  "newBetriebsanweisung",
  "openSdsImport",
  "openCreateRole",
  "openMedkitlogQrCodeDialog",
  "openIncidentReportQrCodeDialog",
];

const DELETE_ACTIONS = [
  "confirmBulkDelete",
  "bulkDeleteEmployees",
  "confirmBulkArchive",
  "bulkArchiveEmployees",
];

export function tableActionAllowed(module, action, selection) {
  if (action === "openMultiUserDialog") {
    return hasPermission("multiusermanagement");
  }
  if (CREATE_ACTIONS.includes(action)) return canCreate(module);
  if (DELETE_ACTIONS.includes(action)) return canBulkDelete(module);
  if (selection) return canBulkEdit(module);
  return true;
}
